import React, { FC, useEffect } from 'react';
import { useViewport } from '../../context';
import { OneColumnLayout } from '../../components/layouts/OneColumnLayout';
import { MobileDomain } from './MobileDomain/MobileDomain';
import { Domain } from './Domain/Domain';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useBiLogger } from '../../hooks/useBiLogger/useBiLogger';
import { BI_CONSTANTS } from '../../hooks/useBiLogger/biConstants';

const queryClient = new QueryClient({});

export interface DomainWrapperProps {}

export const DomainWrapper: FC<DomainWrapperProps> = () => {
  const { isMobile } = useViewport();
  const biLogger = useBiLogger();

  useEffect(() => {
    biLogger.pageView(BI_CONSTANTS.SCREENS.DOMAIN_PAGE);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {isMobile ? <OneColumnLayout content={<MobileDomain />} /> : <Domain />}
    </QueryClientProvider>
  );
};
